import { Card, CardContent } from "@uicomponents/ui/card";
import { AlertCircle } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2">
            <AlertCircle className="h-8 w-8 text-red-500" />
            <h1 className="text-2xl font-bold text-gray-900">
              404 Page Not Found
            </h1>
          </div>

          <p className="mt-4 text-sm text-gray-600">
            Did you forget to add the page to the router?
          </p>
          <p className="mt-4 text-sm text-gray-600">
            Why am I seeing this instead of being redirected? Check the router
            definition that checks the VITE MODE
          </p>
          <p className="mt-4 text-sm text-gray-600">
            <strong>
              If you are seeing this on a hosted page (e.g., staging or
              production), please reach out to the development team.
            </strong>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
